import React from "react";
import styled from "@emotion/styled";
import NavigationButton from "./NavigationButton";
import t from "../../../helper/t";

const RootElement = styled.footer(({ theme }) => ([
    theme.splus3.background.monochrome600,
    theme.splus3.foreground.white,
    theme.splus3.typography.small,
    {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: 120,

        /* for mobile */
        [theme.splus3.breakpoints.mobile]: {
            height: 96,
        },
    }
]));

const ContentDiv = styled.div(({ theme }) => ([
    {
        display: "flex",
        columnGap: 32,
        rowGap: 8,
        margin: 8,
        flexWrap: "wrap",

        /* for mobile */
        [theme.splus3.breakpoints.mobile]: {
            columnGap: 16,
        },
    }
]));

const FooterText = styled.span([
    props => props.theme.splus3.foreground.white,
    props => props.theme.splus3.typography.small,
    {

    }
]);

const Footer: React.FC<{}> = () => {
    return (
        <RootElement>
            <ContentDiv>
                <NavigationButton href="https://www.vodafone.de/">
                    <FooterText>
                        © 2023 {t("Vodafone GmbH")}
                    </FooterText>
                </NavigationButton>
                <NavigationButton href="/privacy_policy_faq" target="_blank">
                    <FooterText>
                        {t("Datenschutz")}
                    </FooterText>
                </NavigationButton>
                <NavigationButton href="https://www.vodafone.de/impressum.html">
                    <FooterText>
                        {t("Impressum")}
                    </FooterText>
                </NavigationButton>
                <NavigationButton href="https://www.vodafone.de/agb.html">
                    <FooterText>
                        {t("AGB")}
                    </FooterText>
                </NavigationButton>
            </ContentDiv>
        </RootElement>
    )
};

export default Footer;

